module.exports = __webpack_public_path__ + "assets/termsConditions.de9a97c45d76fcb6621ca2747e558ef8.html";


//////////////////
// WEBPACK FOOTER
// ./src/components/TermsConditions/termsConditions.html
// module id = 0120
// module chunks = 1